module.exports = __webpack_public_path__ + "static/media/34.290f0522.png";